module.exports = __webpack_public_path__ + "static/media/Roboto-BlackItalic.ac9a9222.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-BlackItalic.woff
// module id = 544
// module chunks = 0